export default "__VITE_ASSET__Dqz3STz5__"